import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { content } from "@/content/translations";

const SiteContext = createContext(null);

export const SiteProvider = ({ children }) => {
    const [lang, setLang] = useState(() => {
        try {
            return localStorage.getItem("chitta-lang") === "vi" ? "vi" : "en";
        } catch {
            return "en";
        }
    });
    const [theme, setTheme] = useState(() => {
        try {
            const saved = localStorage.getItem("chitta-theme");
            if (saved === "dark" || saved === "light") return saved;
            return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
        } catch {
            return "light";
        }
    });

    useEffect(() => {
        const root = document.documentElement;
        root.classList.toggle("dark", theme === "dark");
        root.style.colorScheme = theme;
        try {
            localStorage.setItem("chitta-theme", theme);
        } catch {}
    }, [theme]);

    useEffect(() => {
        document.documentElement.lang = lang;
        document.title = content[lang].meta.title;
        document
            .querySelector('meta[name="description"]')
            ?.setAttribute("content", content[lang].meta.description);
        try {
            localStorage.setItem("chitta-lang", lang);
        } catch {}
    }, [lang]);

    const value = useMemo(
        () => ({
            lang,
            setLang,
            theme,
            toggleTheme: () => setTheme((t) => (t === "dark" ? "light" : "dark")),
            t: content[lang],
        }),
        [lang, theme],
    );

    return <SiteContext.Provider value={value}>{children}</SiteContext.Provider>;
};

export const useSite = () => useContext(SiteContext);
